// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames not based on template
	if (chunkId === 993) return "static/chunks/993.2b3561a230fff3da.js";
	// return url for filenames based on template
	return "static/chunks/" + chunkId + "-" + {"712":"02248030ec4f3d59","909":"8a130c5858dcbe7d","980":"0f088f171fbae5df"}[chunkId] + ".js";
};